// extracted by mini-css-extract-plugin
export default {"manualLabResultEntryContainer":"ManualLabResultsEntry_manualLabResultEntryContainer__2h-ql"};